import React from 'react';
import * as Sentry from '@sentry/browser';

// 错误管理组件
export class ErrorBoundary extends React.Component<{ name?: string }> {
  // @ts-ignore
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  // @ts-ignore
  componentDidCatch(error) {
    console.error(this.props.name, error);
    Sentry.captureException(error);
    this.setState({ hasError: true });
  }
  render() {
    // @ts-ignore
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default ErrorBoundary;
